import React from 'react';
import './product-availability.css';
import { IProductAvailabilityItem } from '../../../../../../../Application/TypewriterModels/IProductAvailabilityItem';

const ProductAvailabilityElement: React.FC<IProductAvailabilityItem> = ({
    product,
    availability,
    availabilityEng,
    latestUpdate,
}) => {
    return (
        <div className="product-availability-item">
            <div className="product">{product}</div>
            <div className="availability">
                <span className={`${availabilityEng} product-item`}>
                    {availability}
                </span>
            </div>
            <div className="latest-update">{latestUpdate}</div>
        </div>
    );
};

export default ProductAvailabilityElement;
